import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Search, FileDown, X } from "lucide-react";
import { Link } from "react-router-dom";
import FilterDropdown from "./FilterDropdown";


const FiltrosComunidadesLegalia = ({ onFilter, filtrosIniciales, user, tieneComunidadCai, tieneComunidadKae }) => {
  const { t } = useTranslation("common");
  const [busqueda, setBusqueda] = useState(filtrosIniciales || {});
    const [estado, setEstado] = useState([]);
    const [disabledCae, setDisabledCae] = useState(false);
    const [disabledLopd, setDisabledLopd] = useState(false);

  useEffect(() => {
    getDatas();
  },[])

  const getDatas = () => {
    const estados = JSON.parse(localStorage.getItem("states")) || [];
    setEstado(estados)
  };

  const handleChange = (name, value) => {
    const updated = { ...busqueda, [name]: value || undefined };
    // Limpiar claves vacías
    for (const key in updated) {
      if (updated[key] === "" || updated[key] === null || updated[key] === undefined) {
        delete updated[key];
      }
    }
    setBusqueda(updated);
    if (name === "estadoCae") setDisabledLopd(!!value);
    if (name === "estadoLopd") setDisabledCae(!!value);
    onFilter(updated);
  };

  const selectStyle = { border: "1px solid #e5e7eb" };
  const inputBase =
    "py-1.5 px-3 text-sm rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-100";

  return (
    <div className="flex flex-wrap items-center gap-3 mb-4">
      <FilterDropdown
        label={t("filters.contractedCae", "Contratado CAE")}
        value={busqueda.estadoCae || ""}
        disabled={disabledCae}
        options={[
          { value: "", label: t("filters.all", "Todos") },
          ...estado.map((s) => ({ value: String(s.id), label: t(`stateNames.${s.nombre}`, s.nombre) })),
        ]}
        onChange={(v) => handleChange("estadoCae", v)}
      />

      <FilterDropdown
        label={t("filters.contractedLopd", "Contratado LOPD")}
        value={busqueda.estadoLopd || ""}
        disabled={disabledLopd}
        options={[
          { value: "", label: t("filters.all", "Todos") },
          ...estado.map((s) => ({ value: String(s.id), label: t(`stateNames.${s.nombre}`, s.nombre) })),
        ]}
        onChange={(v) => handleChange("estadoLopd", v)}
      />
      {user.esCataluna && tieneComunidadKae && (
      <FilterDropdown
        label={t("filters.kae", { defaultValue: "Contratado KAE" })}
        value={busqueda.kaeStatus || ""}
        options={[
          { value: "", label: t("filters.all", { defaultValue: "Todos" }) },
          { value: "activa", label: t("filters.kaeActive", { defaultValue: "Activa" }) },
          { value: "baja", label: t("filters.kaeInactive", { defaultValue: "Baja" }) },
          { value: "anulado", label: t("filters.kaeCancelled", { defaultValue: "Anulado" }) },
        ]}
        onChange={(v) => handleChange("kaeStatus", v)}
      />
      )}
      {user.esProvinciasCai && tieneComunidadCai && (
      <FilterDropdown
        label={t("filters.contractedCai", { defaultValue: "Contratado CAI" })}
        value={busqueda.estadoCai || ""}
        options={[
          { value: "", label: t("filters.all", { defaultValue: "Todos" }) },
          ...estado
            .filter((s) => [1, 4, 5].includes(s.id))
            .map((s) => ({ value: String(s.id), label: t(`stateNames.${s.nombre}`, s.nombre) })),
        ]}
        onChange={(v) => handleChange("estadoCai", v)}
      />
      )}  
      {Object.keys(busqueda).length > 0 && (
        <button
        onClick={() => { setBusqueda({}); setDisabledCae(false); setDisabledLopd(false); onFilter({}); }}
        className={`flex items-center gap-1 ${inputBase} text-red-500 hover:bg-red-50 cursor-pointer`}
        style={selectStyle}
        >
          <X className="w-3.5 h-3.5" />
          {t("actions.clear", "Limpiar")}
        </button>
      )}

      <div className="flex-1" />
      
      <Link
        to={`/doc-render/${user.nif}/situacion-comunidades`}
        target="_blank"
        className="flex items-center gap-2 px-4 py-1.5 text-sm font-semibold text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
        style={{ border: "1px solid #e5e7eb" }}
      >
        {t('aaff:reports.downloadInform')}
        <FileDown className="w-4 h-4" />
      </Link>

      <div className="relative flex items-center">
        <Search className="absolute left-3 w-4 h-4 text-gray-400 pointer-events-none" />
        <input
          type="text"
          placeholder={t("actions.search") + "..."}
          value={busqueda.buscadorGeneral || ""}
          name="buscadorGeneral"
          onChange={(e) => handleChange("buscadorGeneral", e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && onFilter(busqueda)}
          className={`pl-9 pr-4 py-1.5 text-sm rounded-lg bg-white text-gray-900 w-52 focus:outline-none focus:ring-2 focus:ring-blue-100`}
          style={{ border: "1px solid #e5e7eb" }}
        />
      </div>
    </div>
  );
};

export default FiltrosComunidadesLegalia;
